import { MetaFunction } from '@remix-run/node';
import { Link } from '@remix-run/react';
import { HistoryIcon } from 'lucide-react';
import { Container } from '~/components/Container';
import { Layout } from '~/components/Layout';
import { PageHeading } from '~/components/PageHeading';
import { appendMetaTitleSuffix } from '~/lib/utils/meta';

export const loader = async () => {
  return {};
};

export const meta: MetaFunction = () => {
  return [
    { title: appendMetaTitleSuffix('利用規約') },
    { name: 'description', content: 'StompBase（ストンプベース）の利用規約です。' },
    { name: 'robots', content: 'noindex' },
  ];
};

const TermsRoute = () =>  {
  return (
    <Layout>
      <Container>
        <div className={'max-w-[864px] mx-auto'}>

          <PageHeading>
            利用規約
          </PageHeading>

          <div className={'flex items-center text-sm text-slate-400 mb-4'}>
            <HistoryIcon className={'h-4 w-4 mr-1'} />
            2024-05-07
          </div>

          <div className={'text-sm leading-relaxed mb-6'}>
            <div className='mb-2'>ご利用の前には必ず利用規約をお読み下さい。</div>
            <div className='mb-2'>
              StompBase: ストンプベース（以下「当サイト」といいます）は、
              本ウェブサイト上で提供するサービス（以下「本サービス」といいます）の利用に際し、
              以下のとおり利用規約（以下「本規約」といいます）を定めます。
            </div>
            <div>
              当サイトを利用するユーザーは、本規約を承諾した上でご利用しているものと見なします。
            </div>
          </div>

          <h2 className="text-lg font-semibold mb-2">
            著作権
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            当サイト上のテキストと一部の画像は、当サイトまたは当サイトに情報提供した第三者の財産であり、著作権または商標権の対象になります。<br/>
            当サイトで掲載しているテキストや画像などにつきましては、個人・企業問わず、許可なく複製及び転用、販売などの二次利用をすることを禁止します。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            免責事項
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            ・当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。<br/>
            ・当サイトのコンテンツ・情報につきまして、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。<br/>
            ・当サイトに掲載された内容によって生じたトラブル、損害等の一切の責任を負いかねますのでご了承ください。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            規約の変更
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            ・本規約の内容は、法令その他本規約に別段の定めのある事項を除いて、ユーザーに通知することなく変更することができるものとします。<br/>
            ・当サイトが別途定める場合を除いて、変更後の規約は本サイトに掲載したときから効力を生じるものとします。
          </div>

          <h2 className="text-lg font-semibold mb-2">
            お問い合わせ
          </h2>
          <div className={'text-sm leading-relaxed mb-6'}>
            本規約に関するお問い合わせは、
            <Link
              to={`https://forms.gle/QE4BJedNudffqRUA9`}
              className={'text-indigo-600 hover:underline mx-1'}
              target={'_blank'} rel="noreferrer"
            >
              お問い合わせ
            </Link>
            よりお願いいたします。
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default TermsRoute;